import React from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useGlobal } from '../../contexts/GlobalContext';
import { useDocumentTitle } from '../../config/utils';
import logo from '../../assets/img/logo.png';
import landing from '../../assets/img/boy-with-rocket-light.png';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';

export default function Login() {
  useDocumentTitle('Sign In');
  const { login }    = useAuth();
  const { showToast } = useGlobal();
  const navigate      = useNavigate();

  const [formError, setFormError] = React.useState('');
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm();

  const onSubmit = async (data) => {
    setFormError('');
    try {
      await login(data.email, data.password);
      navigate('/dashboard');
    } catch (err) {
      const body = err?.response?.data;
      const first = body?.errors ? Object.values(body.errors)[0] : null;
      // Inline (no reload, no toast needed): the server's own words, never blank.
      setFormError((Array.isArray(first) ? first[0] : first) || body?.message || err.message || 'Sign in failed. Try again.');
    }
  };

  return (
    <div className="min-h-screen bg-bg-primary flex">
      {/* Illustration */}
      <div className="hidden lg:flex flex-1 items-center justify-center p-12 bg-bg-card border-r border-white/[0.08]">
        <div className="text-center max-w-md">
          <img src={landing} alt="Welcome" className="w-80 mx-auto mb-8 opacity-90" />
          <h1 className="text-3xl font-bold text-gradient mb-3">PopupPush Admin</h1>
          <p className="text-text-muted">Manage your screens, clients, and content from one powerful dashboard.</p>
        </div>
      </div>

      {/* Form */}
      <div className="flex flex-col items-center justify-center w-full lg:w-[420px] px-8 py-12">
        <div className="w-full max-w-sm">
          <div className="mb-8 text-center">
            <img src={logo} alt="PopupPush" className="h-10 mx-auto mb-6" />
            <h2 className="text-2xl font-bold text-text-main">Welcome back</h2>
            <p className="text-text-muted text-sm mt-1">Sign in to your admin account</p>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
            {formError && (
              <div role="alert" data-testid="login-error" className="rounded-lg px-4 py-3 text-sm" style={{ background: 'rgba(220,38,38,.12)', border: '1px solid rgba(239,68,68,.5)', color: '#fecaca' }}>{formError}</div>
            )}
            <Input
              label="Email address"
              type="email"
              placeholder="admin@example.com"
              error={errors.email?.message}
              {...register('email', {
                required: 'Email is required',
                pattern: { value: /^\S+@\S+\.\S+$/, message: 'Invalid email address' },
              })}
            />
            <div>
              <Input
                label="Password"
                type="password"
                placeholder="··········"
                error={errors.password?.message}
                {...register('password', { required: 'Password is required' })}
              />
              <div className="mt-1.5 text-right">
                <Link to="/forget-password" className="text-xs text-accent hover:underline">
                  Forgot password?
                </Link>
              </div>
            </div>

            <Button type="submit" loading={isSubmitting} className="w-full justify-center">
              Sign In
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
